import { User } from "../../../../shared/models/user";
import { TextProxy } from "../../../../shared/proxies/text.proxy";
import { getCustomerSettingsWithoutUser } from "../api.service";
import { DocModel } from "../state/state";
import { NO_ERROR } from "../users/users.service";

export let MIN_PASSWORD_LENGTH = 8;
const DIGITS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
const SPECIAL = ["$", "%", "_", "!", "&", "/", "?", ".", "#", "+", "-", ":"];
const UPPERCASE = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
const LOWERCASE = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];
const NONSPECIAL = [...UPPERCASE, ...LOWERCASE, ...DIGITS];

export const passwordPolicy = {
  de: `Das Passwort muss mindestens MIN_PASSWORD_LENGTH Zeichen lang sein, eine Zahl und eines der folgenden Sonderzeichen beinhalten: ${Array.from(
    SPECIAL
  ).join("")}`,
  en: `Please choose a password with MIN_PASSWORD_LENGTH characters or more, at least one digit and one of the following special characters: ${Array.from(
    SPECIAL
  ).join("")}`,
  nl: `Het wachtwoord moet minstens MIN_PASSWORD_LENGTH tekens lang zijn, een cijfer bevatten en één van de volgende speciale tekens: ${Array.from(
    SPECIAL
  ).join("")}`,
};

export async function checkPasswordPolicy(
  text: TextProxy,
  user: User | DocModel,
  customer: string
) {
  let password = "";
  let retypePassword = "";

  MIN_PASSWORD_LENGTH = await getMinPassLengthByCustomer(customer);

  password = user.password;
  retypePassword = user.retypePassword;

  if (typeof password !== "string") {
    return text.profilePassword.passwordNotString;
  }

  if (password.length < MIN_PASSWORD_LENGTH) {
    return (
      text.profilePassword.passwordCount1 +
      MIN_PASSWORD_LENGTH +
      text.profilePassword.passwordCount2
    );
  }

  if (countCharacters(password, SPECIAL) < 1) {
    return (
      text.profilePassword.passwodSpecialCharacters +
      Array.from(SPECIAL).join("")
    );
  }

  if (countCharacters(password, DIGITS) < 1) {
    return text.profilePassword.passwordNumber;
  }

  if (password !== retypePassword) {
    return text.profilePassword.errorRetypedPassword;
  }

  return NO_ERROR;
}

export async function getMinPassLengthByCustomer(customer: string) {
  // TODO: change "pcn" from route because we need this request also when user reset password without being logged in the app
  // const customerSettings = await getCustomerSettingsWithoutUser(customer);
  if (customer === "db" || customer === "karlstorz") {
    return 12;
  } else {
    return MIN_PASSWORD_LENGTH;
    ("");
  }
}

function countCharacters(text: string, characters: string[]) {
  let count = 0;
  for (const c of text) {
    if (characters.includes(c)) {
      count++;
    }
  }
  return count;
}

export function getRandomElement(arr: string[]) {
  const rand = Math.floor(Math.random() * arr.length);
  return arr[rand];
}

export function generateRandomPasswordSelection(length: number) {
  let password = "";

  password += getRandomElement(UPPERCASE);
  password += getRandomElement(LOWERCASE);
  password += getRandomElement(SPECIAL);
  password += getRandomElement(DIGITS);

  for (let i = 4; i < length; i++) {
    password += getRandomElement([...NONSPECIAL, ...SPECIAL]);
  }

  // let shuffled = password
  //   .split("")
  //   .sort(function () {
  //     return 0.5 - Math.random();
  //   })
  //   .join("");
  return password;
}
